export default __webpack_public_path__ + "static/media/qsms_bg.72a2e0ae.png";